import React, { useEffect } from "react";
import { mapSocketFactory } from "../../../../utils/socketFactory";
import { useDispatch, useSelector } from "react-redux";
import { FormControlLabel } from "@mui/material";
import IOSSwitch from "../../../../components/IOSSwitch";
import { Menu, MenuItem } from "@mui/material";
import './ModerateParticipants.css'
import { useState } from "react";
import { changeRole } from "../../../Conference/store/ActiveConferenceThunks";
import { updateParticipantStatus } from "../../../ControlPanel/store/Conference/ConferenceThunks";
import { LOWER_HAND_TO_ROOM } from "../../../MediaControls/store/raisedHandsSlice";
import { useTranslation } from "react-i18next";
export default function ModerateParticipants({ joinedParticipants }) {
    const dispatch = useDispatch()
    const {t}= useTranslation();

    const {
        uiState,
        conference,
    } = useSelector((state) => state.activeConference);

    const currentRoom = useSelector((state) => state.MapDisplay.currentRoom);

    const { localAvatar } = useSelector((state) => state.auth);
    const [searchTerm, setSearchTerm] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [activeMenuId, setActiveMenuId] = useState(null);
    const [activeDates, setActiveDates] = useState([]);

    const changeConferenceAccess = (type, value) => {
        if (mapSocketFactory && mapSocketFactory.socket) {
            if (!mapSocketFactory.socket.connected) {
                console.error("⛔ ÉCHEC ÉMISSION: La socket est déconnectée ou en reconnexion.", {
                    id: mapSocketFactory.socket.id,
                    ready_state: mapSocketFactory.socket.readyState
                });
                return;
            }
            mapSocketFactory.socket.emit('setAllowAcessConference', { conferenceId: conference.id, type, allow_Access: value, sender: localAvatar?.display_name, senderId: localAvatar?.id });
        }
    }
    const changeParticipantAccess = (participantId, type, value) => {
        if (mapSocketFactory && mapSocketFactory.socket) {
            if (!mapSocketFactory.socket.connected) {
                console.error("⛔ ÉCHEC ÉMISSION: La socket est déconnectée ou en reconnexion.", {
                    id: mapSocketFactory.socket.id,
                    ready_state: mapSocketFactory.socket.readyState
                });
                return;
            }
            mapSocketFactory.socket.emit('setAllowAcessParticipant', { participantId, type, allow_Access: value, sender: localAvatar?.display_name });
        }
    }
    const filteredParticipants = joinedParticipants.filter(p => {
        const searchableName = p.display_name || p.email || "";
        const matchesSearch = searchableName.toLowerCase().includes(searchTerm.toLowerCase());
        const isValidRole = ["guest_externe", "guest"].includes(p.role);
        return matchesSearch && isValidRole;
    });

    // ==========================================
    // DEBUGGING LOGS (Check your browser console)
    // ==========================================
    /* console.log("--- DEBUGGING PARTICIPANTS ---");
     console.log("1. Raw participants from Redux:", conference.participants);
     console.log("2. Safe participants:", safeParticipants);
     console.log("3. Avatars data from Redux:", avatarsData);
     console.log("5. Search Term:", searchTerm);
     console.log("6. Filtered Results:", filteredParticipants);
     console.log("------------------------------");*/
    //    console.log("4. Joined participants:", joinedParticipants);


    const masterParticipants = joinedParticipants.filter(p => p.role === "master");
    const handRaisedParticipants = joinedParticipants
        .filter(p => p.isHandRaised === true)
        .sort((a, b) => a.rank - b.rank);

    const userNameLog = (data) => {
        if (!data?.user) return t("UNDEFINED_USER");
        if (data.role === "guest_externe" && data.user.firstName === "Guest") {
            return data.email || `${data.user.firstName} ${data.user.lastName}`.trim();
        }
        return `${data.user.firstName} ${data.user.lastName}`.trim() || t("UNDEFINED_USER");
    };
    const formatLogs = (data = []) => {
        return [...data]
            .sort((a, b) => new Date(b.date) - new Date(a.date))
            .map(item => {
                const dateObj = new Date(item.date);
                const day = String(dateObj.getDate()).padStart(2, "0");
                const month = String(dateObj.getMonth() + 1).padStart(2, "0");
                const year = dateObj.getFullYear();
                const hours = String(dateObj.getHours()).padStart(2, "0");
                const minutes = String(dateObj.getMinutes()).padStart(2, "0");
                return {
                    date: `${day}/${month}/${year}`,
                    time: `${hours}:${minutes}`,
                    type: item.type,
                    user: userNameLog(item),
                    label: item.description,
                    rawDate: dateObj
                };
            });
    };

    const groupByDate = (data) => {
        return data.reduce((acc, item) => {
            if (!acc[item.date]) acc[item.date] = [];
            acc[item.date].push(item);
            return acc;
        }, {});
    };

    const formatDateLabel = (dateStr) => {
        const [d, m, y] = dateStr.split("/");
        const date = new Date(`${y}-${m}-${d}`);
        const today = new Date();
        const yesterday = new Date();
        yesterday.setDate(today.getDate() - 1);
        if (date.toDateString() === today.toDateString()) return "Aujourd'hui";
        if (date.toDateString() === yesterday.toDateString()) return "Hier";
        return dateStr;
    };

    const iconClass = (type) => {
        switch (type) {
            case "bans": return "block";
            case "attendance": return "visibility";
            case "emails": return "mail";
            case "registration": return "edit_document";
            case "system": return "settings";
            default: return "info";
        }
    };

    const handleToggleDate = (date) => {
        setActiveDates(prev =>
            prev.includes(date)
                ? prev.filter(d => d !== date)
                : [...prev, date]
        );
    };

    // ───────── PREPARE LOGS DATA ─────────
    const logsData = conference?.actions ? formatLogs(conference.actions) : [];
    const groupedLogs = groupByDate(logsData);
    const sortedDates = Object.keys(groupedLogs).sort((a, b) => {
        const [d1, m1, y1] = a.split("/");
        const [d2, m2, y2] = b.split("/");
        return new Date(`${y2}-${m2}-${d2}`) - new Date(`${y1}-${m1}-${d1}`);
    });
    useEffect(() => {
        if (sortedDates.length > 0 && activeDates.length === 0) {
            setActiveDates([sortedDates[0]]);
        }
    }, [sortedDates.length]);
    return (
        <div className="moderation-container">
            <div className="global-rules">
                <h3 className="global-rules-title">{t('global_rules')}</h3>
                <div className="rules-container">
                    <div className="rule-container">
                        <div className="rule-info">
                            <span
                                className="material-symbols-outlined rule-icon"
                                style={{ color: conference.allow_camera ? '#479A32' : '#EF4444' }}
                            >
                                videocam
                            </span>
                            <span className="rule-name">{t('camera_participants')}</span>
                        </div>
                        <div>
                            <FormControlLabel
                                control={
                                    <IOSSwitch
                                        colorvariant="standard"
                                        checked={conference.allow_camera === true}
                                        onChange={(e) => {
                                            changeConferenceAccess("allow_camera", e.target.checked ? true : false
                                            );
                                        }}
                                    />
                                }
                                sx={{ marginTop: "0.625rem", marginLeft: "1px", display: "flex", alignItems: "center", gap: "0.625rem" }}
                            />
                        </div>
                    </div>
                    <div className="rule-container">
                        <div className="rule-info">
                            <span
                                className="material-symbols-outlined rule-icon"
                                style={{ color: conference.allow_mic ? '#479A32' : '#EF4444' }}
                            >
                                mic
                            </span>
                            <span className="rule-name">{t('microphone_participants')}</span>
                        </div>
                        <div>
                            <FormControlLabel
                                control={
                                    <IOSSwitch
                                        colorvariant="standard"
                                        checked={conference.allow_mic === true}
                                        onChange={(e) => {
                                            changeConferenceAccess("allow_mic", e.target.checked ? true : false
                                            );
                                        }}
                                    />
                                }
                                sx={{ marginTop: "0.625rem", marginLeft: "1px", display: "flex", alignItems: "center", gap: "0.625rem" }}
                            />
                        </div>
                    </div>
                    <div className="rule-container">
                        <div className="rule-info">
                            <span
                                className="material-symbols-outlined rule-icon"
                                style={{ color: conference.allow_screen_share ? '#479A32' : '#EF4444' }}
                            >
                                screen_share
                            </span>
                            <span className="rule-name">{t('screen_share')}</span>
                        </div>
                        <div>
                            <FormControlLabel
                                control={
                                    <IOSSwitch
                                        colorvariant="standard"
                                        checked={conference.allow_screen_share === true}
                                        onChange={(e) => {
                                            changeConferenceAccess("allow_screen_share", e.target.checked ? true : false
                                            );
                                        }}
                                    />
                                }
                                sx={{ marginTop: "0.625rem", marginLeft: "1px", display: "flex", alignItems: "center", gap: "0.625rem" }}
                            />
                        </div>
                    </div>
                    <div className="rule-container">
                        <div className="rule-info">
                            <span
                                className="material-symbols-outlined rule-icon"
                                style={{ color: conference.allow_messages ? '#479A32' : '#EF4444' }}
                            >
                                forum
                            </span>
                            <span className="rule-name">{t('messaging')}</span>
                        </div>
                        <div>
                            <FormControlLabel
                                control={
                                    <IOSSwitch
                                        colorvariant="standard"
                                        checked={conference.allow_messages === true}
                                        onChange={(e) => {
                                            changeConferenceAccess("allow_messages", e.target.checked ? true : false
                                            );
                                        }}
                                    />
                                }
                                sx={{ marginTop: "0.625rem", marginLeft: "1px", display: "flex", alignItems: "center", gap: "0.625rem" }}
                            />
                        </div>
                    </div>
                </div>
            </div>
            <div className="global-rules">
                <h3 className="global-rules-title"> {t('raised_hands')} ({handRaisedParticipants.length})</h3>
                <div className="raised-hands-list">
                    {handRaisedParticipants.map((participant, index) => {
                        const permissions = participant.accesses && participant.accesses.length > 0
                            ? participant.accesses[0]
                            : {};
                        return (

                            <div key={participant.id} className="raised-hand-item">
                                <div className="raised-hand-info">
                                    <span className="number-circle">{participant.rank}</span>
                                    <span className="raised-hand-name">{participant.display_name}</span>
                                </div>

                                <div className="raised-hand-controls">
                                    <div className="controls-participant">
                                        <span className="control-btn control-access-mic"
                                            onClick={() => {
                                                changeParticipantAccess(participant.conference_user_id, "allow_mic", true);
                                                LOWER_HAND_TO_ROOM({
                                                    sender: participant?.user_id,
                                                    senderEmail: participant?.email,
                                                    roomId: currentRoom?.room_id
                                                })
                                            }}>
                                            <span className="material-symbols-outlined  mic-icon-hand">mic</span>
                                            <span className="control-label control-access-label">{t('allow_speech')}</span>
                                        </span>

                                        <span className="control-btn control-access-camera"
                                            onClick={() => {
                                                changeParticipantAccess(participant.conference_user_id, "allow_mic", true);
                                                changeParticipantAccess(participant.conference_user_id, "allow_camera", true);
                                                LOWER_HAND_TO_ROOM({
                                                    sender: participant?.user_id,
                                                    senderEmail: participant?.email,
                                                    roomId: currentRoom?.room_id
                                                })
                                            }}>
                                            <span className="material-symbols-outlined  mic-icon-hand">mic</span>
                                            <span className="control-label control-access-label">{t('allow_camera')}</span>
                                        </span>
                                    </div>
                                    <span className="control-btn control-access-close"
                                        onClick={() => {
                                            LOWER_HAND_TO_ROOM({
                                                sender: participant?.user_id,
                                                senderEmail: participant?.email,
                                                roomId: currentRoom?.room_id
                                            })
                                        }}>
                                        <span className="material-symbols-outlined close-hand-icon">close</span>
                                    </span>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>

            <div className="normal-participants-container">
                <h3 className="global-rules-title"> {t('the_participants')} ({filteredParticipants.length})</h3>
                <div className="search-container" style={{ marginTop: "0" }}>
                    <input
                        type="text"
                        placeholder={t('search_participant')}
                        className="search-input-conference"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                    />
                    <svg className="search-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                        <circle cx="11" cy="11" r="8"></circle>
                        <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                    </svg>
                </div>
                <div className="participants-container">
                    {filteredParticipants.map((participant, index) => {
                        const permissions = participant.accesses && participant.accesses.length > 0
                            ? participant.accesses[0]
                            : {};
                        return (
                            <div key={index} className="participant-card-info">
                                <div className="conference-participant-info">
                                    <div className="participant-init" >
                                        {participant.initials}
                                    </div>
                                    <div className="info-container">
                                        <div className="participant-name-row">
                                            <span className="conference-participant-name" title={participant.display_name}>{participant.display_name}</span>
                                        </div>
                                        <div className="participant-type-function">
                                            {participant.role === "guest_externe" &&
                                                <span className="participant-type">
                                                    {t('external')}
                                                </span>
                                            }
                                            {participant.mic_state === 1 &&
                                                <span className="participant-function">
                                                    {t('speaking')}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="conference-participant-action">
                                    <div className="permissions-icons">
                                        <span
                                            className="material-symbols-outlined permission-icon"
                                            style={{
                                                color: permissions?.allow_mic ? '#079455' : '#EF4444',
                                                background: permissions?.allow_mic ? '#BAEDCD' : '#FAC5C5',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                changeParticipantAccess(participant.conference_user_id, "allow_mic", !permissions?.allow_mic);
                                            }}
                                        >
                                            {permissions?.allow_mic ? 'mic' : 'mic_off'}
                                        </span>
                                        <span
                                            className="material-symbols-outlined permission-icon"
                                            style={{
                                                color: permissions?.allow_camera ? '#079455' : '#EF4444',
                                                background: permissions?.allow_camera ? '#BAEDCD' : '#FAC5C5',
                                                cursor: 'pointer'

                                            }}
                                            onClick={() => {
                                                changeParticipantAccess(participant.conference_user_id, "allow_camera", !permissions?.allow_camera);
                                            }}
                                        >
                                            {permissions?.allow_camera ? 'videocam' : 'videocam_off'}

                                        </span>
                                        <span
                                            className="material-symbols-outlined permission-icon"
                                            style={{
                                                color: permissions?.allow_screen_share ? '#079455' : '#EF4444',
                                                background: permissions?.allow_screen_share ? '#BAEDCD' : '#FAC5C5',
                                                cursor: 'pointer'
                                            }}
                                            onClick={() => {
                                                changeParticipantAccess(participant.conference_user_id, "allow_screen_share", !permissions?.allow_screen_share);
                                            }}
                                        >
                                            {permissions?.allow_screen_share ? 'screen_share' : 'stop_screen_share'}
                                        </span>
                                    </div>
                                    <div className="options-menu">
                                        <span className="material-symbols-outlined"
                                            style={{ cursor: "pointer", color: "gray" }}
                                            onClick={(e) => {
                                                setAnchorEl(e.currentTarget);
                                                setActiveMenuId(participant.conference_user_id);
                                            }}>
                                            more_vert
                                        </span>
                                        <Menu
                                            anchorEl={anchorEl}
                                            open={activeMenuId === participant.conference_user_id}
                                            onClose={() => {
                                                setAnchorEl(null);
                                                setActiveMenuId(null);
                                            }}
                                            anchorOrigin={{
                                                vertical: 'bottom',
                                                horizontal: 'left',
                                            }}
                                            transformOrigin={{
                                                vertical: 'top',
                                                horizontal: 'right',
                                            }}
                                            slotProps={{
                                                paper: {
                                                    sx: {
                                                        display: 'inline-flex',
                                                        padding: '0.5rem',
                                                        flexDirection: 'column',
                                                        alignItems: 'flex-start',
                                                        gap: '0.25rem',
                                                        borderRadius: '1rem',
                                                        border: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                                                        background: '#FFF',
                                                        boxShadow: '0 12px 16px -4px var(--Colors-Effects-Shadows-shadow-lg_01, rgba(10, 13, 18, 0.08)), 0 4px 6px -2px var(--Colors-Effects-Shadows-shadow-lg_02, rgba(10, 13, 18, 0.03)), 0 2px 2px -1px var(--Colors-Effects-Shadows-shadow-lg_03, rgba(10, 13, 18, 0.04))',
                                                        '& .MuiList-root': {
                                                            padding: 0,
                                                            display: 'flex',
                                                            flexDirection: 'column',
                                                            gap: '0.25rem',
                                                            width: '100%'
                                                        }
                                                    }
                                                }
                                            }}
                                        >
                                            <MenuItem
                                                disabled={participant.role === "guest_externe"}
                                                sx={{
                                                    display: 'flex',
                                                    padding: '0.5rem',
                                                    alignItems: 'center',
                                                    gap: '1rem',
                                                    alignSelf: 'stretch',
                                                    borderRadius: '0.5rem',
                                                    width: '100%',
                                                    color: '#496ADB'
                                                }}
                                                onClick={() => {
                                                    dispatch(changeRole({ body: { participantId: participant.conference_user_id } }));
                                                    setAnchorEl(null);
                                                    setActiveMenuId(null);
                                                }}
                                            >
                                                <span className="material-symbols-outlined">
                                                    add_moderator
                                                </span>
                                                {t('promote_to_master')}
                                            </MenuItem>

                                            <MenuItem
                                                sx={{
                                                    display: 'flex',
                                                    padding: '0.5rem',
                                                    alignItems: 'center',
                                                    gap: '1rem',
                                                    alignSelf: 'stretch',
                                                    borderRadius: '0.5rem', // Optional
                                                    width: '100%',
                                                    color: '#EF4444'

                                                }}
                                                onClick={() => {
                                                    dispatch(updateParticipantStatus({
                                                        body: {
                                                            conferenceId: participant.reservation_id,
                                                            email: participant.email,
                                                            status: "banni"
                                                        }
                                                    }))
                                                    setAnchorEl(null);
                                                    setActiveMenuId(null);
                                                }}
                                            >
                                                <span className="material-symbols-outlined">
                                                    block
                                                </span>
                                                {t('ban_from_session')}
                                            </MenuItem>
                                        </Menu>
                                    </div>

                                </div>

                            </div>
                        )
                    })}
                </div>

            </div>

            <div className="normal-participants-container">
                <h3 className="global-rules-title"> {t("the_masters")} ({masterParticipants.length})</h3>
                <div className="participants-container">
                    {masterParticipants.map((participant, index) => {
                        const permissions = participant.accesses && participant.accesses.length > 0
                            ? participant.accesses[0]
                            : {};
                        return (
                            <div key={index} className="participant-card-info">
                                <div className="conference-participant-info">
                                    <div className="participant-init" >
                                        {participant.initials}
                                    </div>
                                    <div className="info-container">
                                        <div className="participant-name-row">
                                            <span className="conference-participant-name">{participant.display_name}</span>
                                        </div>
                                        <div className="participant-type-function">
                                            {participant.mic_state === 1 &&
                                                <span className="participant-function">
                                                    {t("speaking")}
                                                </span>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="conference-participant-action">
                                    <div className="permissions-icons">
                                        <span
                                            className="material-symbols-outlined permission-icon"
                                            style={{
                                                color: permissions?.allow_mic ? '#079455' : '#EF4444',
                                                background: permissions?.allow_mic ? '#BAEDCD' : '#FAC5C5',
                                            }}
                                        >
                                            {permissions.allow_mic ? 'mic' : 'mic_off'}
                                        </span>
                                        <span
                                            className="material-symbols-outlined permission-icon"
                                            style={{
                                                color: permissions.allow_camera ? '#079455' : '#EF4444',
                                                background: permissions?.allow_camera ? '#BAEDCD' : '#FAC5C5',

                                            }}
                                        >
                                            {permissions.allow_camera ? 'videocam' : 'videocam_off'}

                                        </span>
                                        <span
                                            className="material-symbols-outlined permission-icon"
                                            style={{
                                                color: permissions?.allow_screen_share ? '#079455' : '#EF4444',
                                                background: permissions?.allow_screen_share ? '#BAEDCD' : '#FAC5C5',


                                            }}
                                        >
                                            {permissions?.allow_screen_share ? 'screen_share' : 'stop_screen_share'}
                                        </span>
                                    </div>
                                    {uiState.master.is_principal_master &&
                                        <div className="options-menu">
                                            <span className="material-symbols-outlined"
                                                style={{ cursor: "pointer", color: "gray" }}
                                                onClick={(e) => {
                                                    setAnchorEl(e.currentTarget);
                                                    setActiveMenuId(participant.conference_user_id);
                                                }}>
                                                more_vert
                                            </span>
                                            <Menu
                                                anchorEl={anchorEl}
                                                open={activeMenuId === participant.conference_user_id}
                                                onClose={() => {
                                                    setAnchorEl(null);
                                                    setActiveMenuId(null);
                                                }}
                                                anchorOrigin={{
                                                    vertical: 'bottom',
                                                    horizontal: 'left',
                                                }}
                                                transformOrigin={{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                }}
                                                slotProps={{
                                                    paper: {
                                                        sx: {
                                                            display: 'inline-flex',
                                                            padding: '0.5rem',
                                                            flexDirection: 'column',
                                                            alignItems: 'flex-start',
                                                            gap: '0.25rem',
                                                            borderRadius: '1rem',
                                                            border: '1px solid var(--Grey-modern-Border, #CDD5DF)',
                                                            background: '#FFF',
                                                            boxShadow: '0 12px 16px -4px var(--Colors-Effects-Shadows-shadow-lg_01, rgba(10, 13, 18, 0.08)), 0 4px 6px -2px var(--Colors-Effects-Shadows-shadow-lg_02, rgba(10, 13, 18, 0.03)), 0 2px 2px -1px var(--Colors-Effects-Shadows-shadow-lg_03, rgba(10, 13, 18, 0.04))',
                                                            '& .MuiList-root': {
                                                                padding: 0,
                                                                display: 'flex',
                                                                flexDirection: 'column',
                                                                gap: '0.25rem',
                                                                width: '100%'
                                                            }
                                                        }
                                                    }
                                                }}
                                            >
                                                <MenuItem
                                                    sx={{
                                                        display: 'flex',
                                                        padding: '0.5rem',
                                                        alignItems: 'center',
                                                        gap: '1rem',
                                                        alignSelf: 'stretch',
                                                        borderRadius: '0.5rem',
                                                        width: '100%',
                                                        color: '#496ADB'
                                                    }}
                                                    onClick={() => {
                                                        dispatch(changeRole({ body: { participantId: participant.conference_user_id } }));
                                                        setAnchorEl(null);
                                                        setActiveMenuId(null);
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined">
                                                        add_moderator
                                                    </span>
                                                    {t("remove_master")}
                                                </MenuItem>

                                                <MenuItem
                                                    sx={{
                                                        display: 'flex',
                                                        padding: '0.5rem',
                                                        alignItems: 'center',
                                                        gap: '1rem',
                                                        alignSelf: 'stretch',
                                                        borderRadius: '0.5rem', // Optional
                                                        width: '100%',
                                                        color: '#EF4444'

                                                    }}
                                                    onClick={() => {
                                                        dispatch(updateParticipantStatus({
                                                            body: {
                                                                conferenceId: participant.reservation_id,
                                                                email: participant.email,
                                                                status: "banni"
                                                            }
                                                        }))
                                                        setAnchorEl(null);
                                                        setActiveMenuId(null);
                                                    }}
                                                >
                                                    <span className="material-symbols-outlined">
                                                        block
                                                    </span>
                                                    {t("ban_from_session")}
                                                </MenuItem>
                                            </Menu>
                                        </div>
                                    }

                                </div>



                            </div>
                        )
                    })}
                </div>

            </div>

            {conference?.actions && conference.actions.length > 0 && (
                <div className="global-rules-container-actions">
                    <h3 className="global-rules-title">Journal d'actions</h3>
                    <div className="logs-container-actions">
                        {sortedDates.map(date => {
                            const isActive = activeDates.includes(date);
                            return (
                                <div key={date} className={`log-group ${isActive ? "active" : ""}`}>
                                    <h3 className="log-date">
                                        <span className="date-info">
                                            {formatDateLabel(date)}
                                            <span className="actions-count">{groupedLogs[date].length} Action{groupedLogs[date].length > 1 && 's'}</span>
                                        </span>
                                        <span 
                                            className="material-symbols-outlined" 
                                            style={{ cursor: "pointer" }}
                                            onClick={() => handleToggleDate(date)}
                                        >
                                            {isActive ? "keyboard_arrow_down" : "keyboard_arrow_right"}
                                        </span>
                                    </h3>
                                    <div className="logs-list"  style={{ display: isActive ? "block" : "none" }}>
                                        {groupedLogs[date].map((log, i) => (
                                            <div key={i} className="log-item">
                                                <div className="log-time">{log.time}</div>
                                                <div className="log-content">
                                                    <span className={`log-icon type-icon-${log.type} material-symbols-outlined`}>
                                                        {iconClass(log.type)}
                                                    </span>
                                                    <div className="log-text">
                                                        <span className="d-block">
                                                            {t(log.label, { name: log.user })}
                                                        </span>
                                                        <span className={`badge ${log.type}`}>
                                                            {t(log.type)}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

        </div>
    );
}